import React from 'react';
import { Provider } from 'react-redux';
import * as r from 'react-router';

import history from './history';
import MobileContainer from '../gui/MobileContainer';
import DetailContainer from '../detail/DetailContainer';
import Business from '../business';
import Imprint from '../imprint';


import ReactGA from 'react-ga';
ReactGA.initialize('UA-112591944-1', {
  debug: true,
});
ReactGA.pageview(window.location.pathname + window.location.search);




const Routes = ({ store }) => {
  return (
    <Provider store={store}>
      <r.Router history={history}>
      	<div>
	        <r.Route exact path="/app" component={MobileContainer} />
          <r.Route exact path="/business" component={Business} />
          <r.Route exact path="/imprint" component={Imprint} />

	        <r.Route path="/app/detail/:id" component={DetailContainer} />
	        <r.Route path="*" component={MobileContainer} />
        </div>
      </r.Router>
    </Provider>
  );
};

// Routes.propTypes = {
//   store: storeShape.isRequired,
// };

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js